"use client"

import React, { Suspense } from "react"
import { BrowserRouter as Router } from "react-router-dom"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

import { AuthProvider } from "./contexts/AuthContext"
import { DashboardProvider } from "./contexts/DashboardContext"
import { AppProvider } from "./contexts/AppContext"
import { GlobalControls } from "./components/layout/GlobalControls"
import { AppRoutes } from "./routes/AppRoutes"
import { LoadingSpinner } from "./components/ui/LoadingSpinner"

// Main App component
function App() {
    return (
        <Router>
            <AuthProvider>
                <DashboardProvider>
                    <AppProvider>
                        <ToastContainer
                            position="top-right"
                            autoClose={3000}
                            hideProgressBar={false}
                            newestOnTop
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                            theme="light"
                        />
                        <Suspense fallback={<LoadingSpinner />}>
                            <AppRoutes />
                        </Suspense>
                        <GlobalControls />
                    </AppProvider>
                </DashboardProvider>
            </AuthProvider>
        </Router>
    )
}

export default App